import React from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/Header.css';

const Header: React.FC = () => {
    const navigate = useNavigate();

    return (
        <header className="site-header">
            <div className="header-content">
                <h1 
                    className="site-title"
                    onClick={() => navigate('/')}
                >
                    Articles
                </h1>
                <nav className="site-navigation">
                    <ul>
                        <li><a href="/admin">Admin</a></li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;